import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import ExportarDanger from "./../../../assets/ExportarDanger.svg";
import ExportarSucess from "./../../../assets/ExportarSucess.svg";
import { Col, Row } from "react-bootstrap";
import TableFormaPago from "./Tabla";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import SelectOrdenamiento from "../../../Includes/SelectOrdenamiento";
import Buscador from "../../../Includes/Buscador";
import { getLista } from "../Funciones/FormaPago";
import ModalTarjeta from "./Dialogos/ModalTarjeta";

const FormaPago = () => {

  const [ValueSelect, setValueSelect] = useState("1");
  const [ValueBusqueda, setValueBusqueda] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [Lista, setLista] = useState([]);
  const [showModalTarjeta, setShowModalTarjeta] = useState(false)

  useEffect(() => {
    getListaFormaPago();
  }, [ValueBusqueda, ValueSelect]);

  const getListaFormaPago = () => {
    setIsLoading(true);
    getLista()
      .then((resp) => {
        let list = JSON.parse(resp.data);
        setLista(list);
        setIsLoading(false);
      })
      .catch((resp) => {
        setLista([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    document.title = `FormaPago`;
    //const horarios = generarHorarios("09:36:00", "15:47:00", 30);
    //console.log("horarios generados: ", horarios);
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap my-4">
        <div className="p-2">
          <h4 className="text-left font-AvenirBold">Formas de pago suscripción</h4>
        </div>
        <div className="p-2">
          <Stack spacing={2} direction={{ xs: "column", sm: "row" }}> 
            <Button className="btn btn-Kalendar px-4 " variant="contained" onClick={() => {
              setShowModalTarjeta(true)
            }}>
              Añadir nueva
            </Button>
          </Stack>
        </div>
      </div>

      <Card variant="outlined" className="p-0 shadow">
        <Row className="p-3">
          <Col xs={12} md={8}>
            <Buscador
              placeholder="Buscar formas de pago por nombre"
              ValueBusqueda={ValueBusqueda}
              setValueBusqueda={setValueBusqueda}
            />
          </Col>
          <Col xs={12} md={4}>
            <SelectOrdenamiento
              ValueSelect={ValueSelect}
              setValueSelect={setValueSelect}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <TableFormaPago
              Lista={Lista ?? []}
              IsLoading={IsLoading}
              setLista={setLista}
            ></TableFormaPago>
          </Col>
        </Row>
      </Card>

      {
        showModalTarjeta && (
          <ModalTarjeta
            id={0}
            getTarjetas={getLista}
            setShowModalTarjeta={setShowModalTarjeta}
          />
        )
      }
    </>
  );
};

export default FormaPago;
